import React, { useState } from 'react';
import { Modal } from '@/components/ui/modal';

interface ImagePreviewProps {
  children: React.ReactElement<React.ImgHTMLAttributes<HTMLImageElement>>;
  className?: string;
  imageUrl: string;
}

const ImagePreview: React.FC<ImagePreviewProps> = ({ children, className, imageUrl }) => {
  const [isOpen, setIsOpen] = useState(false);

  if (!React.isValidElement(children) || children.type !== 'img') {
    console.warn('ImagePreview component only accepts img elements as children');
    return children;
  }

  const imgProps = children.props;

  return (
    <>
      <div
        className={`group cursor-pointer relative ${className || ''}`}
        onClick={() => setIsOpen(true)}
      >
        <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity rounded-lg flex items-center justify-center">
          <svg
            className="w-8 h-8 text-white"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.7955 15.8111L21 21M18 10.5C18 14.6421 14.6421 18 10.5 18C6.35786 18 3 14.6421 3 10.5C3 6.35786 6.35786 3 10.5 3C14.6421 3 18 6.35786 18 10.5Z"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
        {React.cloneElement(children, {
          ...imgProps,
          className: `${imgProps.className || ''} outline-[0px] transition-all duration-100 hover:outline hover:outline-[2px] outline-brand-400`
        })}
      </div>

      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        className="p-0 bg-transparent shadow-none flex items-center justify-center"
        maxWidth="fit-content"
      >
        <img
          src={imageUrl}
          alt={imgProps.alt}
          className="max-w-[1000px] h-auto max-h-[85vh] object-contain rounded-lg"
        />
      </Modal>
    </>
  );
};

export default ImagePreview;
